import { defineAction } from "../classes/ActionDefinition";
export default defineAction({
    name: 'System.HelloWorld',
    async execute(data, params) {
        //Data
        host.notification.showToast("Hello World", "warning");
        return this.Ok();
    }
});
